import { serializeStyles } from '@emotion/serialize'
import { insertStyles } from '@emotion/utils'
import { isFunction, isObject } from 'lodash'

import context from './context'
import { css } from '../system/css.js'

/**
 * This implementation is a remix of the emotion:
 * https://github.com/emotion-js/emotion/tree/master/packages/css/src
 * Refer to the LICENSE for emotion here: https://github.com/emotion-js/emotion
 */

// TODO: if not in browser ... add <style> of rules
export function BeerDS(styles, props, isStringTag = false) {
  const serialized = serializeStyles(
    styles,
    context.registered,
    props,
  )

  insertStyles(context, serialized, isStringTag)
  return `${context.key}-${serialized.name}`
}

let memo = {}

export function clearMemo() {
  memo = {}
}

export function MemoBeerCls(ds, props = {}, isStringTag = false) {
  const { theme, ...restProps } = props
  const args = [theme.name]
  Object.keys(restProps)
    .filter(k => !isFunction(restProps[k]) && !isObject(restProps[k]))
    .forEach(k => {
      args.push(`${k}-${(restProps[k] || '').toString()}`)
    })
  Object.keys(ds)
    .forEach(k => {
      args.push(`${k}-${(ds[k] || '').toString()}`)
    })
  const key = args.join('_') || '__no_args__'
  if (memo[key]) return memo[key]
  memo[key] = BeerDS([
    css(ds)(props),
  ], {
    props,
  }, isStringTag)
  return memo[key]
}

export function BeerCls(ds, props = {}, extra = [], isStringTag = false) {
  return BeerDS([
    css(ds)(props),
    ...extra,
  ], {
    props,
  }, isStringTag)
}

export function BeerStrCls(ds, props = {}) {
  return BeerDS([
    css(ds)(props),
  ], {
    props,
  }, true)
}

function insertWithoutScoping(cache, serialized) {
  let result
  if (cache.inserted[serialized.name] === undefined) {
    result = cache.insert('', serialized, cache.sheet, true)
  }
  return result
}

export const keyframes = (...args) => {
  const serialized = serializeStyles(args, context.registered)
  const animation = `animation-${serialized.name}`

  insertWithoutScoping(context, {
    name: serialized.name,
    styles: `@keyframes ${animation}{${serialized.styles}}`,
  })

  return animation
}

export const injectGlobal = (...args) => {
  const serialized = serializeStyles(args, context.registered)
  insertWithoutScoping(context, serialized)
}

export default BeerDS
